import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {AppConstant} from './app/shared/utility/app-constant';

declare global {
  interface Window {
    __CYPRESS_RUNNING__?: boolean;
  }
}

if (!window.__CYPRESS_RUNNING__ && (environment.env === 'QA' || environment.env === 'Production')) {
  Sentry.init({
    dsn: 'https://50151dd88c506ff907a7e7b7eb0d2dfd@o4509648236838912.ingest.us.sentry.io/4509648266461184',
    release: 'papertrl-angular@'+require('package.json').version,
    sendDefaultPii: true,
    ignoreErrors: AppConstant.SENTRY_IGNORE_ERROR_STRING,
    environment: environment.env,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations:
      [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
      ],

    beforeSend(event, hint) {
      const isElectron = navigator.userAgent.includes('Electron');

      if (isElectron) {
        return null;
      }

      const errorMessage = event?.exception?.values?.[0]?.value || event?.message;
      if (!errorMessage || errorMessage === '<Unknown>' || errorMessage.includes('Unknown') ||
        errorMessage === '<unknown>' || errorMessage.includes('unknown')) {
        return null;
      }
      return event;
    },
  });

  const tenantId = JSON.stringify(localStorage.getItem(AppConstant.SUB_CLIENT_ID) ||
    JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR))?.tenantId);

  const email = JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR))?.email;

  if (email || tenantId) {
    Sentry.setUser({
      id: tenantId,
      email
    });
  }
}


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
